import { I18N } from 'aurelia-i18n';
import { Container, Aurelia, autoinject } from 'aurelia-framework';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from '../../../Code/Helpers/StringHelper';


@autoinject
export class CustomNumberFormatterBaseValueConverter {
    protected i18n: I18N = null;

    constructor(i18n: I18N) {
        this.i18n = i18n;
    }

    toView(value, options, locale, type, configJson) {
        if (value === null
            || typeof value === 'undefined'
            || (typeof value === 'string' && value.trim() === '')
        ) {
            return value;
        }

        if (ObjectHelper.IsNullOrUndefined(options)) {
            options = {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }
        }
        if (ObjectHelper.ObjectIs(configJson) && ObjectHelper.ObjectIs(configJson.FieldConfig) && StringHelper.StringIs(configJson.FieldConfig.ReadOnlyFormat)) {
            switch (configJson.FieldConfig.ReadOnlyFormat) {
                case 'HoursMinutes':
                    return `${moment.duration(value, 'hours').hours()}h ${moment.duration(value, 'hours').minutes()}m`
                    break
            }
        }
        return this.i18n.nf(options, locale || this.i18n.getLocale()).format(value);
    }

    fromView(value, options, locale) {
        return this.i18n.uf(value, this.i18n.getLocale());
    }
}